export class loginModel {
    email: string = '';
    password: string = '';
}

export class resetPasswordModel {
    email: string = '';
}